
import { signalRService } from './SignalRService';

export type AppReadyHandler = () => void;
export type AppReadyDisposeHandler = () => void;

export class AppReadyService {
    private subscribers: AppReadyHandler[] = [];

    constructor() {
        signalRService.onInitialized(() => {
            this.subscribers.forEach((cb) => cb());
        });
    }

    onAppReady(cb: AppReadyHandler): AppReadyDisposeHandler {
        this.subscribers.push(cb);
        return () => (this.subscribers = this.subscribers.filter((sub) => sub !== cb));
    }
}
